export default __webpack_public_path__ + "static/media/exe.80b40534.svg";